import React, { useState, useEffect } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import CentrikaIcon from "../../assets/img/logo.png";
import OperatorLogo from "../../assets/img/bus.png";
import SafariLogo from "../../assets/img/logo.svg";

import {
  Button,
  Drawer,
  ListItemText,
  IconButton,
  ListItemIcon,
  ListItem,
  Divider,
  List,
  Grid,
  Paper,
  Typography,
  Toolbar,
  AppBar,
  Container,
  Box,
  Hidden,
  Menu,
  MenuItem,
  Avatar,
  useMediaQuery,
  Badge,
  ButtonBase,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

import {
  Menu as MenuIcon,
  Home,
  Equalizer,
  Settings,
  ExitToApp,
  ArrowDropDown,
  HelpRounded,
  Notifications,
  Group,
  SupervisedUserCircle,
  Store,
  Security,
  AllInclusive,
  Gavel,
  Money,
  Schedule,
  Subway,
  AirportShuttle,
  CreditCard,
  Block,
  Mail,
  Place,
  DepartureBoard,
  Assignment,
  Category,
  Assessment,
  ExpandLess,
  ExpandMore,
  ArrowRight,
  Timeline,
  MoneyOff,
  LocalAtm,
  WbIncandescentOutlined,
  DevicesOther,
  ArrowForwardIos,
  GroupAdd,
  Portrait,
  People,
  SwapHoriz
} from "@material-ui/icons";

import { makeStyles, useTheme } from "@material-ui/styles";
import { Speed } from "@material-ui/icons";

import { withLocalize, Translate } from "react-localize-redux";

import { Link, Switch, Route, useHistory } from "react-router-dom";


import { Permissions } from "./../operator/../../utils/web_config_2";


import Dashboard from "./../operator/dashboard.jsx";
import Outlet from "./../operator/outletes.jsx";
import Offense from "./../operator/offenses.jsx";
import SSchedule from "./../operator/schedule.jsx";
import Stop from "./../operator/stop.jsx";
import RRoute from "./../operator/route.jsx";
import Vehicle from "./../operator/vehicle";
import Driver from "./../operator/driver.jsx";
import Users from "./../operator/users";
import UserRoute from "./../operator/user_route";
import Fines from "./../operator/fines";
import CategoryOffense from "./../operator/category_offense";
import Commissions from "./../operator/commissions";
import Deductions from "./../operator/deductions";
import SSettings from "./../operator/settings";

import RouteSchedule from "./../operator/route_schedule";
import Devices from "./../operator/devices";

import Members from "./../operator/users_members";
import PosAgent from "./../operator/user_route2";



// report 
// import Dailyfinetreport from "./../operator/daily_fine_report"; 
// import FinesReport from "./../operator/fine_report";
// import DailyTicketReport from "./../operator/daily_bus_report";
// import BusTicketReport from "./../operator/tickets_report";

import ReportPOS from "./../operator/report_pos";
import ReportUser from "./../operator/report_user";
import ReportBus from "./../operator/report_bus";
import ReportBranch from "./../operator/report_branch";
import ReportTraffic from "./../operator/report_traffic";
import ReportSettlement from "./../operator/report_settlement";
import ReportFine from "./../operator/daily_fine_report";
import ReportBusinessOverview from "./../operator/report_business_overview";
import ReportManifesto from "./../operator/report_manifesto";

import API from "./../operator/api";

import UserInfo from "./../operator/login_info";

import { useSnackbar } from "notistack";
import { addMinutes } from "date-fns/fp";

const routes = [
  {
    path: "/operator",
    exact: true,
    main: () => <Dashboard />,
  },
  {
    path: "/centrika/operator/home",
    exact: true,
    main: () => <Dashboard />,
  },
  {
    path: "/centrika/operator/branch",
    exact: true,
    main: () => <Outlet />,
  },
  {
    path: "/centrika/operator/categoryoffense",
    exact: true,
    main: () => <CategoryOffense />,
  },
  {
    path: "/centrika/operator/offense",
    exact: true,
    main: () => <Offense />,
  },
  {
    path: "/centrika/operator/fine",
    exact: true,
    main: () => <Fines />,
  },
  {
    path: "/centrika/operator/commissions",
    exact: true,
    main: () => <Commissions />,
  },
  {
    path: "/centrika/operator/stop",
    exact: true,
    main: () => <Stop />,
  },
  {
    path: "/centrika/operator/route",
    exact: true,
    main: () => <RRoute />,
  },
  {
    path: "/centrika/operator/schedule",
    exact: true,
    main: () => <RouteSchedule />,
  },
  {
    path: "/centrika/operator/schedule/:id",
    exact: true,
    main: () => <SSchedule />,
  },
  {
    path: "/centrika/operator/vehicle",
    exact: true,
    main: () => <Vehicle />,
  },
  {
    path: "/centrika/operator/driver",
    exact: true,
    main: () => <Driver />,
  },
  {
    path: "/centrika/operator/userRoute",
    exact: true,
    main: () => <UserRoute />,
  },
  {
    path: "/centrika/operator/posAgent",
    exact: true,
    main: () => <PosAgent />,
  },
  {
    path: "/centrika/operator/members",
    exact: true,
    main: () => <Members />,
  },
  {
    path: "/centrika/operator/tickets",
    exact: true,
    main: () => <Typography></Typography>,
  },
  {
    path: "/centrika/operator/settings",
    exact: true,
    main: () => <SSettings />,
  },
  {
    path: "/centrika/operator/users",
    exact: true,
    main: () => <Users />,
  },
  {
    path: "/centrika/operator/deductions",
    exact: true,
    main: () => <Deductions />,
  },
  {
    path: "/centrika/operator/settlementreport",
    exact: true,
    main: () => <ReportSettlement />,
  },
  {
    path: "/centrika/operator/trafficreport",
    exact: true,
    main: () => <ReportTraffic />,
  },
  {
    path: "/centrika/operator/dailyposreport",
    exact: true,
    main: () => <ReportPOS />,
  },
  {
    path: "/centrika/operator/userreport",
    exact: true,
    main: () => <ReportUser />,
  },
  {
    path: "/centrika/operator/busreport",
    exact: true,
    main: () => <ReportBus />,
  },
  {
    path: "/centrika/operator/branchreport",
    exact: true,
    main: () => <ReportBranch />,
  },
  {
    path: "/centrika/operator/finesreport",
    exact: true,
    main: () => <ReportFine />,
  },
  {
    path: "/centrika/operator/businessoverviewreport",
    exact: true,
    main: () => <ReportBusinessOverview />,
  },
  {
    path: "/centrika/operator/devices",
    exact: true,
    main: () => <Devices />,
  },
  {
    path: "/centrika/operator/manifestoreport",
    exact: true,
    main: () => <ReportManifesto />,
  },
  {
    main: () => (
      <Dashboard />
    ),
  },
];


const getMenus = () => {


  const menus = [
    { name: <Translate id="operator_menu.home" />, icon: <Home />, path: "/centrika/operator/home", permissions: "INITIAL" },
    { name: "Business Overview", icon: <WbIncandescentOutlined />, path: "/centrika/operator/businessoverviewreport", permissions: "CAN_DOWNLOAD_DAILY_SALES_REPORT" },
    { name: <Translate id="operator_menu.branch_outlet" />, icon: <AllInclusive />, path: "/centrika/operator/branch", permissions: "CAN_DOWNLOAD_DAILY_SALES_REPORT" },
    { name: <Translate id="operator_menu.categoryoffense" />, icon: <Category />, path: "/centrika/operator/categoryoffense", permissions: "CAN_DOWNLOAD_DAILY_SALES_REPORT" },
    { name: <Translate id="operator_menu.offense" />, icon: <Gavel />, path: "/centrika/operator/offense", permissions: "CAN_DOWNLOAD_DAILY_SALES_REPORT" },
    { name: <Translate id="operator_menu.commissions" />, icon: <Money />, path: "/centrika/operator/commissions", permissions: "CAN_DOWNLOAD_DAILY_SALES_REPORT" },
    { name: <Translate id="operator_menu.deductions" />, icon: <MoneyOff />, path: "/centrika/operator/deductions", permissions: "CAN_DOWNLOAD_DAILY_SALES_REPORT" },
    { name: <Translate id="operator_menu.stop" />, icon: <Place />, path: "/centrika/operator/stop", permissions: "CAN_VIEW_STOPS_LIST" },
    { name: <Translate id="operator_menu.route" />, icon: <Subway />, path: "/centrika/operator/route", permissions: "CAN_VIEW_ROUTE" },
    { name: <Translate id="operator_menu.schedules" />, icon: <Schedule />, path: "/centrika/operator/schedule", permissions: "CAN_LIST_SCHEDULE" },
    { name: <Translate id="operator_menu.vehicle" />, icon: <AirportShuttle />, path: "/centrika/operator/vehicle", permissions: "CAN_LIST_VEHICLE" },
    { name: <Translate id="operator_menu.driver" />, icon: <SupervisedUserCircle />, path: "/centrika/operator/driver", permissions: "CAN_LIST_DRIVER" },
    { name: "Devices", icon: <DevicesOther />, path: "/centrika/operator/devices", permissions: "CAN_LIST_DEVICE" },
    { name: <Translate id="operator_menu.user_route" />, icon: <DepartureBoard />, path: "/centrika/operator/userRoute", permissions: "CAN_VIEW_POS_USER" },
    { name: "POS agents", icon: <GroupAdd />, path: "/centrika/operator/posAgent", permissions: "CAN_VIEW_POS_USER" },
    new UserInfo().ORG_TP == "COOPERATIVE" ? { name: "Members", icon: <Portrait />, path: "/centrika/operator/members", permissions: "CAN_VIEW_POS_USER" } : {},
    {
      name: "Reports",
      icon: <Timeline />,
      path: "/centrika/operator/reports",
      submenu: [
        // { name: "Daily Fine Tickets", path: "/centrika/operator/dailyfinetickets" },
        // { name: "Daily Bus Tickets",  path: "/centrika/operator/dailybustickets" },
        // { name: "Bus Tickets",path: "/centrika/operator/bustickets" },
        // { name: "Fine Tickets", path: "/centrika/operator/finetickets"},
        { name: "Daily Traffic Report", path: "/centrika/operator/trafficreport" },
        // { name: "Daily settlement",  path: "/centrika/operator/settlementreport" },
        { name: "Sales Report", path: "/centrika/operator/dailyposreport" },
        { name: "User Report", path: "/centrika/operator/userreport" },
        { name: "Bus Report", path: "/centrika/operator/busreport" },
        { name: "Branch Report", path: "/centrika/operator/branchreport" },
        // { name: "Manifesto Report",  path: "/centrika/operator/manifestoreport" },
        { name: "Fines Report", path: "/centrika/operator/finesreport" },
      ], permissions: "CAN_DOWNLOAD_DAILY_SALES_REPORT"
    },
    {
      name: "Settlement Report",
      icon: <LocalAtm />,
      path: "/centrika/operator/reports",
      submenu: [
        { name: "Daily Settlement Transactions", path: "/centrika/operator/settlementreport" },
        // { name: "Settlement Transaction Batches",  path: "/centrika/operator/settlementbatchreport" }
      ],
      permissions: "CAN_DOWNLOAD_DAILY_SALES_REPORT"
    }
  ];

  return menus;
}

const menus2 = [
  { name: <Translate id="operator_menu.user" />, icon: <HelpRounded />, path: "/centrika/operator/users", permissions: "CAN_VIEW_ORG_USER" },
  { name: <Translate id="operator_menu.setting" />, icon: <Settings />, path: "/centrika/operator/settings", permissions: "INITIAL" },
  { name: <Translate id="operator_menu.logout" />, icon: <ExitToApp />, path: "/centrika/operator/logout", permissions: "INITIAL" },
];

const drawerWidth = 250;

const useStyles = makeStyles((theme) => ({
  root: {},
  title: {
    flexGrow: 1,
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    border: 0,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  btn: {
    textTransform: "capitalize",
  },
  paper: {
    padding: 15,
  },
  icon: {
    height: 45,
    marginRight: 10,
    display: "block",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    borderRadius: 10,
  },
  operatorLogo: {
    height: 100,
  },
}));

function OperatorViewer(props) {
  const { window } = props;
  const classes = useStyles();
  const Theme = useTheme();
  const history = useHistory();
  const { admin } = props

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const menuOpen = Boolean(anchorEl);
  const [logoutOpen, setLogoutOpen] = useState(false);

  const [openMenu, setOpenMenu] = useState("none");
  const [operatorMenus, setOperatorMenus] = useState([]);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>
      <div className={classes.toolbar} />

      <Divider />
      <List>
        {operatorMenus.filter((m) => m.name !== undefined).map((menu, index) => (
          <Permissions permissions={menu.permissions}>
            <div>
              {" "}
              <ListItem
                button
                key={menu.name}
                onClick={() => {
                  if (menu.submenu) {
                    if (openMenu == index) {
                      setOpenMenu("none");
                    } else {
                      setOpenMenu(index);
                    }
                  } else {
                    history.push(menu.path);
                  }
                  setMobileOpen(false);
                }}
                selected={menu.path == history.location.pathname}
              >
                <ListItemIcon>{menu.icon}</ListItemIcon>
                <ListItemText primary={menu.name} />
                {menu.submenu ? (
                  openMenu == index ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )
                ) : (
                  <div />
                )}
              </ListItem>
              {menu.submenu && (
                <Collapse in={openMenu == index} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {menu.submenu.map((sub, i) => (
                      <ListItem
                        button
                        className={classes.nested}
                        onClick={() => {
                          history.push(sub.path);
                          setMobileOpen(false);
                        }}
                        selected={sub.path == history.location.pathname}
                      >
                        <ListItemIcon>
                          <ArrowRight />
                        </ListItemIcon>
                        <ListItemText primary={sub.name} />
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              )}
            </div>
          </Permissions>
        ))}
      </List>

      <Divider />
      <List>
        {menus2.map((menu, index) => (

          <Permissions permissions={menu.permissions}>
            <ListItem
              button
              key={menu.name}
              onClick={() => {
                if (menu.path === "/centrika/operator/logout") {
                  setLogoutOpen(true);
                } else {
                  history.push(menu.path);
                }
              }}
            >
              <ListItemIcon>{menu.icon}</ListItemIcon>
              <ListItemText primary={menu.name} />
            </ListItem>
          </Permissions>
        ))}
      </List>
    </div>
  );

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const container =
    window !== undefined ? () => window().document.body : undefined;
  const matches = useMediaQuery(Theme.breakpoints.up("sm"));

  useEffect(() => {

    var data = {};
    const data1 = localStorage.getItem("nx_op");
    if (data1 != null) {
      data = JSON.parse(data1);

      if (data.token == null) {
        history.replace("/");
        return;
      }
    } else {
      history.replace("/", { expired: true });
    }
    var menus = getMenus();
    setOperatorMenus(menus)
  }, []);


  return (
    <div className={classes.root}>
      <CssBaseline />
      <Dialog
        open={logoutOpen}
        onClose={() => setLogoutOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Logout"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to logout of your account?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLogoutOpen(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              localStorage.removeItem("nx_op");
              localStorage.removeItem("profile");
              history.replace("/");
            }}
            color="primary"
            autoFocus
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
      <AppBar position="fixed" elevation={0} className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <img src={OperatorLogo} alt="icon" className={classes.icon} />
          <Box className={classes.title}>
            <Typography variant={matches ? "h5" : "h6"} noWrap>
              {new UserInfo().ORG_NAME}
            </Typography>
          </Box>



          <Box ml={matches && 2}>
            <Button onClick={() => {
              localStorage.removeItem('nx_op')
              localStorage.removeItem('profile')
              history.replace("/centrika/operators")

            }} endIcon={<ArrowForwardIos />} color='secondary' variant='contained' disableElevation className={classes.btn}>Back to Admin</Button>
          </Box>


        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="Agent menus">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={Theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Switch>
          {routes.map((route, i) => (

            <Route
              key={i}
              exact={route.exact}
              path={route.path}
              component={route.main}
            />
          ))}
        </Switch>
      </main>
    </div >
  );
}

export default withLocalize(OperatorViewer);
